var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-dashboard"},[_c('div',{staticClass:"ui container"},[_c('h2',{staticClass:"title"},[_vm._v("Análise por grupo")]),_c('t-table-gender'),_c('t-table-classification'),_c('t-table-age')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }